import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { createPortal } from 'react-dom';
import { Dialog, DialogContent } from '@mui/material';
import DialogTitleForMutation from './DialogTitleForMutation';

const ModalExplanationMutation = (props, ref) => {

  const { mutationType } = props;

  const modalElement = document.getElementById(`modal-${mutationType}`);

  const [ isOpen, setIsOpen ] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  };

  useImperativeHandle(ref, () => ({
    open: () => setIsOpen(true),
  }), []);

  const dialogTitleId = `dialog-title-${Date.now()}`;

  const createModal = () => {
    if (isOpen) {
      return <Dialog
        open={isOpen}
        onClose={closeModal}
        className={'modal-explanation'}
        maxWidth={props.maxWidth || 'sm'}
        fullWidth={true}
        aria-labelledby={dialogTitleId}
      >
        <DialogTitleForMutation id={dialogTitleId} mutationType={mutationType} closeFn={closeModal} />
        <DialogContent sx={{
          padding: 0,
        }}>
          {props.children}
        </DialogContent>
      </Dialog>;

    } else {
      return null;
    }
  };

  return createPortal(
    createModal(),
    modalElement,
  );
};

export default forwardRef(ModalExplanationMutation);
